export default {
      id: "i-burger-usage",
      viewBox: "0 0 18 15",
      url: __webpack_public_path__ + "img/sprite.svg#i-burger",
      toString: function () {
        return this.url;
      }
    }